import React from "react";
import Link from "next/link";
import PropTypes from "prop-types";
import classnames from "classnames/bind";
import { Breadcrumb } from "@aqar-app/aqar-design-system";
import styles from "./cardContainer.module.scss";
import Message from "../message/Message";

const cx = classnames.bind(styles);
const { BreadcrumbItem } = Breadcrumb;
const CardContainer = ({
  title,
  subTitle,
  children,
  cardClassName,
  cardContainerClassName,
  message,
  breadcrumbItems,
  ...rest
}) => {
  return (
    <div className={cx(cardContainerClassName, styles.container)} {...rest}>
      <div className={styles.row}>
        <div className={styles.col}>
          <h1 className={styles.title}>{title}</h1>
          {subTitle && <div className={styles.subTitle}>{subTitle}</div>}
          {breadcrumbItems && (
            <div className={styles.breadcrumbContainer}>
              <Breadcrumb data-cy="breadcrumb">
                {breadcrumbItems.map(({ name, path }) => (
                  <BreadcrumbItem key={path}>
                    <Link href={path}>{name}</Link>
                  </BreadcrumbItem>
                ))}
              </Breadcrumb>
            </div>
          )}
          <div className={cx(cardClassName, styles.card)}>
            <>
              {message && <Message text={message} />}
              {children}
            </>
          </div>
        </div>
      </div>
    </div>
  );
};

CardContainer.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  cardContainerClassName: PropTypes.string,
  cardClassName: PropTypes.string,
  message: PropTypes.string,
  children: PropTypes.node,
  breadcrumbItems: PropTypes.arrayOf(
    PropTypes.shape({ name: PropTypes.string, path: PropTypes.string }),
  ),
};

CardContainer.defaultProps = {
  title: "",
  subTitle: "",
  cardContainerClassName: "",
  cardClassName: "",
  message: undefined,
  children: null,
  breadcrumbItems: undefined,
};

export default CardContainer;
